import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 180000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(
  (config) => {
    // Check if the request method is GET

      // Add a custom header
    config.headers['uuid'] = localStorage.getItem("uuid");

    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.request.use(

)

export default axiosInstance
